<template>
  <div>

    <a-tabs  @change="(type)=>{getList(1,type)}" :default-active-key="activeKey+''">
    <a-tab-pane key="2" tab="待审核">
      <div class="seachBox flex">
        <div class="seachList"><span class="name">兑换类型：</span>
          <a-select v-model="seach.type2.exchange_name" class="seachs" allowClear>
            <a-select-option :value="item.exchange_name" :key="index" v-for="(item,index) in seachList.type2.industry">
              {{item.exchange_name}}
            </a-select-option>
          </a-select>
        </div>
        <div class="seachList"><span class="name">兑换日期：</span>
          <a-range-picker class="seachs" v-model="seach.type2.create_time"   :showTime="false" :allowClear="false"    format="YYYY-MM-DD"  />
        </div>
        <div class="seachList ">
          <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
            查询
          </a-button>
          <a-button size="default" class="seachBtn" @click="resetSeach(2)">重置</a-button>
        </div>
        <div class="seachList no"></div>
        <div class="seachList no"></div>
      </div>
     <a-table :columns="columns2" :data-source="datas"   :pagination="pagination" rowKey="id"
      >
       <template slot="action" slot-scope="text,record">
<!--         <a-popconfirm-->
<!--             title="确定要审核通过么?"-->
<!--             ok-text="确定"-->
<!--             cancel-text="取消"-->
<!--             @confirm=""-->
<!--             @cancel="()=>{}"-->
<!--         >-->
           <a @click="audit(record)">审核</a>
<!--         </a-popconfirm>-->
       </template>

     </a-table>
    </a-tab-pane>
    <a-tab-pane key="1" tab="已生效" force-render>
      <div class="seachBox flex">
        <div class="seachList"><span class="name">兑换类型：</span>
          <a-select v-model="seach.type1.exchange_name" class="seachs" allowClear>
            <a-select-option :value="item.exchange_name" :key="index" v-for="(item,index) in seachList.type1.industry">
              {{item.exchange_name}}
            </a-select-option>
          </a-select>
        </div>
        <div class="seachList"><span class="name">兑换日期：</span>
          <a-range-picker class="seachs" v-model="seach.type1.create_time"   :showTime="false" :allowClear="false"    format="YYYY-MM-DD"  />
        </div>
        <div class="seachList  ">
          <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
            查询
          </a-button>
          <a-button size="default" class="seachBtn" @click="resetSeach(1)">重置</a-button>
        </div>
        <div class="seachList no"></div>
        <div class="seachList no"></div>
      </div>
      <a-table :columns="columns" :data-source="datas"   :pagination="pagination" rowKey="id"
      > </a-table>
    </a-tab-pane>
  </a-tabs></div>
</template>

<script>
import API from "../api"
import moment from "moment"
import {removeById} from "../../../../utils/utils"
const columns = [
  {
    title: "兑换类型",
    dataIndex: "exchange_name",
    ellipsis: true,
    key: "exchange_name",
  },
  {
    title: "兑换规则",
    dataIndex: "exchange_rule",
    ellipsis: true,
    key: "exchange_rule"
  },
  {
    title: "兑换日期",
    dataIndex: "create_time",
    ellipsis: true,
    key: "create_time",
  },
  {
    title: "生效日期",
    key: "audit_text",
    dataIndex: "audit_text",
    scopedSlots: {customRender: "audit_text"}
  },

];

const columns2 = [
  {
    title: "兑换类型",
    dataIndex: "exchange_name",
    ellipsis: true,
    key: "exchange_name",
  },
  {
    title: "兑换规则",
    dataIndex: "exchange_rule",
    ellipsis: true,
    key: "exchange_rule",
    scopedSlots: {customRender: "rule_left"}
  },
  {
    title: "兑换日期",
    dataIndex: "create_time",
    ellipsis: true,
    key: "create_time",
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    width: "180px",
    scopedSlots: {customRender: "action"}
  },

];
export default {
  name: "record",
  data(){
    return{
      seach: {
        type1:{exchange_name: "", create_time: "" },
        type2:{exchange_name: "", create_time: "" }
      },
      seachList: {
        type1:{ industry: [],},
        type2:{ industry: [],}

      },
      exportData:{},
      activeKey:this.$route.query.type,
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      datas: [],
      columns:columns,
      columns2:columns2,
      type:""
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/CustomerPoints/CustomerPointsList"; //设置左侧导航2-2 active
  },
  mounted() {
    this.getList()
  },
  methods:{
    audit(row) {
      let _this=this
      this.$confirm({
        title: '确认',
        okText:"确定" ,
        cancelText:"取消" ,
        content: "确定要审核通过么?",
        onOk() {
          API.service.AUDIT({id:row.id}).then(res => {

            if(res.data.code==200){
              _this.$message.success(res.data.msg,1.5)
            }
            _this.getList()
          })
        },
        onCancel() {},
      });

    },
    resetSeach(type) {
      this.loading = true
      this.seach[`type${type}`] = {
        exchange_name: "",
        create_time: "",
      }
      this.getList(1)
    },
    getList(page,type ) {
      let seachData=JSON.parse(JSON.stringify(this.seach))
      if (seachData.type1.create_time.length > 0 ) {
        seachData.type1.create_time[0] = moment(this.seach.type1.create_time[0]).format('YYYY-MM-DD')
        seachData.type1.create_time[1] = moment(this.seach.type1.create_time[1]).format('YYYY-MM-DD')
      }else{
        seachData.type1.create_time=[]
      }
      if (seachData.type2.create_time.length > 0 ) {
        seachData.type2.create_time[0] = moment(this.seach.type2.create_time[0]).format('YYYY-MM-DD')
        seachData.type2.create_time[1] = moment(this.seach.type2.create_time[1]).format('YYYY-MM-DD')
      }else{
        seachData.type2.create_time=[]
      }
      if(type)this.type=type
      let typeSub=type||this.type||this.$route.query.type||2
      seachData[`type${typeSub}`].id=this.$route.query.id

      seachData[`type${typeSub}`].type=typeSub

      API.service.GET_LIST_RECORD({page: page || 1, ...seachData[`type${typeSub}`]}).then(res => {
        this.datas = res.data.data.list.data
        this.pagination.total = res.data.data.list.total
        this.pagination.pageSize = res.data.data.list.per_page
        this.pagination.current = res.data.data.list.current_page
        this.seachList[`type${typeSub}`].industry = res.data.data.exchange_category
        this.$store.state.company = res.data.data.company;
      })
    },},
  components:{ }
}
</script>

<style scoped>
@media(max-width:1500px){
  .seachBox .seachList {
    width: 24.5%;
  }

}
</style>
